(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-training-modal
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.cancel :refer [cancel]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.code :refer [code]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.user :as d-user]

            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]))




(defn parse-date [date]
  ;(log/debug "################### " date "-->" (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)))
  (js/Date.parse (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8))))

(defn date-conv [date & [or-add-years]]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (if (and (not (nil? date)) (> (count (str date)) 12))
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    (let [now (js/Date.)
          y (.getFullYear now)
          y (if or-add-years (+ or-add-years y) y)
          m (inc (.getMonth now))
          m (if (> m 9) m (str "0" m))
          d (.getDate now)
          d (if (> d 9) d (str "0" d))]
      (str y "-" m "-" d))
    ))

(defn date-conv-add [date add-years]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (if (and (not (nil? date)) (> (count (str date)) 12))
    (str (+ (parse-long (subs date 0 4)) add-years) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    (let [now (js/Date.)
          m (inc (.getMonth now))
          m (if (> m 9) m (str "0" m))
          d (.getDate now)
          d (if (> d 9) d (str "0" d))]
      (str (+ add-years (.getFullYear now)) "-" m "-" d))
    ))

(defn date-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" "120000.000Z"))






;(in-ns 'teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-training-modal)

;"20180701T100000"






(defn reject-form [!st document]
  (let [!rejectMessage (r/cursor !st [:userDocument-rejectMessage])]
    [mui/grid {:container  true
               :direction  "row"
               :justify    "space-between"
               :spacing    2
               :multiline  true
               :rowsMin    3
               :style      {:paddingRight "5px"}
               :alignItems "flex-start"}
     [mui/grid {:container false :item true :xs 12}
      "Ablehnung Begründung"]
     [mui/grid {:container false :item true :xs 12}
      [mui/text-field {
                       :style           {:background-color (if (:userDocument-rejectMessage @!st) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "text"
                       :autoOk          true
                       :error           (= "" @!rejectMessage)
                       :helper-text     (if (= "" @!rejectMessage) "Bitte Begründung eingeben" "")
                       :onChange        (fn [e] (swap! !st assoc :userDocument-rejectMessage (h/event-value e)))
                       :label           (str " ")
                       :defaultValue    (str "" (:userDocument-rejectMessage @!st))
                       :InputLabelProps {:disableAnimation true :shrink true}
                       }]
      ]
     ]
    ))


(defn qualification-document-form [!st date-to-ok?]
  (let []
    [mui/grid {:container  true
               :direction  "row"
               :style      {:paddingRight "5px"}
               :error      (< (count (str (:userDocument-type @!st))) 1)
               :justify    "space-between"
               :spacing    2
               :alignItems "flex-start"}


     [mui/grid {:container false :item true :xs 6}
      [mui/text-field {
                       :style           {:background-color (if (:userDocument-validFrom @!st) "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "date"
                       :autoOk          true
                       :error           false
                       :helperText      " "
                       :onChange        (fn [e] (swap! !st assoc :userDocument-validFrom (h/event-value e)))
                       :label           (str "Gültig von ")
                       :value           (:userDocument-validFrom @!st)
                       :InputLabelProps {:disableAnimation true :shrink true}
                       }]
      ]
     [mui/grid {:container false :item true :xs 6}
      [mui/text-field {
                       ;:style {:background-color (if (not= (:lrClearance-end @!st) (:lrClearance-end wop-clearance))  "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "date"
                       :style           {:background-color (if (:userDocument-validTo @!st) "#ffd6d2" "#ffffff")}
                       :autoOk          true
                       :error           (if date-to-ok? false true)
                       :helperText      (if-not date-to-ok? "`Gültig bis` < Jetzt " " ")
                       :onChange        (fn [e] (swap! !st assoc :userDocument-validTo (h/event-value e)))
                       :label           (str "Gültig bis ")
                       :value           (if (:userDocument-validTo @!st) (:userDocument-validTo @!st) "")
                       :InputLabelProps {:disableAnimation true :shrink true}
                       }]
      ]

     [mui/grid {:container false :item true :xs 6}
      [mui/button {:size    "small"
                   :variant "contained"
                   :onClick (fn []
                              (let [newDate (date-conv-add (date-conv-back (:userDocument-validFrom @!st)) 2)]
                                (log/debug "Add 24 Month " (:userDocument-validFrom @!st) "->" newDate)
                                (swap! !st assoc :userDocument-validTo newDate)))
                   }
       "+ 2 Jahre"]
      ]
     [mui/grid {:container false :item true :xs 6}
      [mui/button {:size    "small"
                   :variant "contained"
                   :onClick (fn []
                              (let [newDate (date-conv-add (date-conv-back (:userDocument-validFrom @!st)) 5)]
                                (log/debug "Add 5 Years " (:userDocument-validFrom @!st) "->" newDate)
                                (swap! !st assoc :userDocument-validTo newDate)))
                   }
       "+ 5 Jahre"]
      ]

     [mui/grid {:container false :item true :xs 12 :style {:height "5px"}}]
     ])
  )



(defn modal [!actual-user document !show & [!show-doc-assign-modal qualification-validate?]]
  (let [{:keys [userDocument-fileName userDocument-path userDocument-type userDocument-uuid userDocument-validFrom
                userDocument-validTo userDocument-rejected userDocument-rejectMessage userDocument-isTraining uploaded]} document
        active-clearance (d-user/get-active-clearance @!actual-user)
        !invalidated (r/cursor vstate/app-state [:lr-list :invalidated])
        !st (r/atom {:reject                            userDocument-rejected
                     :lrClearance-type                  (or (:lrClearance-type active-clearance) "")
                     :lrClearance-qualification-message (or (:lrClearance-qualification-message active-clearance) "")
                     :userDocument-rejectMessage        userDocument-rejectMessage
                     :userDocument-type                 userDocument-type
                     :userDocument-validFrom            (date-conv userDocument-validFrom 0)
                     :userDocument-validTo              (date-conv userDocument-validTo 0)})
        !reject (r/cursor !st [:reject])
        !rejectMessage (r/cursor !st [:userDocument-rejectMessage])
        !validFrom (r/cursor !st [:userDocument-validFrom])
        !validTo (r/cursor !st [:userDocument-validTo])
        !lrClearance-qualification-message (r/cursor !st [:lrClearance-qualification-message])
        {:keys [user-uuid user-tomId user-lastName user-firstName user-birthday]} @!actual-user]
    (fn []
      (log/debug "actual-user-clearance" (clj->js active-clearance))
      (let [confirmable? (and
                           (not= "" (:lrClearance-type @!st))
                           (> (count (str @!validFrom)) 5)
                           (> (count (str @!validTo)) 5)
                           )
            date-to-ok? (< (.getTime (new js/Date)) (parse-date (date-conv-back @!validTo)))]
        ;(reset! !document-type userDocument-type)
        [mui/modal
         {:className        "training-modal"
          :dataClearance    active-clearance
          :aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (or @!show false)

          }

         [:div
          {
           :class "modal"
           :style {:minWidth 700 :maxWidth 900}}
          [mui/grid {:container  true
                     :direction  "row"
                     :justify    "space-between"
                     :alignItems "flex-start"}
           [mui/grid {:container false :item true :xs 12}
            [:h2
             (if (:userDocument-isTraining document)
               (str "Qualifikationsnachweis ")
               (str "Qualifikationsnachweis prüfen "))
             ]]

           [mui/grid {:container false :item true :xs 6}
            [:div


             [mui/typography {} "Bitte überprüfe:"
              [:br]
              [mui/form-label {:style {:font-size "12px"}} "Qualifiziert durch"
               [mui/select
                {
                 :style     {:font-size "16px" :margin-top "4px" :background-color (if (not= (:lrClearance-type @!st) (:lrClearance-type active-clearance)) "#ffd6d2" "#ffffff")}
                 :fullWidth true
                 :onChange  (fn [e v] (log/debug "type change " (h/event-value e)) (swap! !st assoc :lrClearance-type (h/event-value e)))
                 :value     (str "" (:lrClearance-type @!st))
                 }
                (for [[k n] (sort-by second (txt/txt :fake :lr-types))]
                  ^{:key (str "type-" k)}
                  [mui/menu-item {:value k} n])
                ]]
              [:br] "Dokument hochgeladen am:  " (date-conv uploaded)
              [:br]
              [:br] "Name: " [:a {:href (str "/#user-view$" user-tomId) :target "_blank"} [:span {:style {:color "blue"}} "`" user-lastName ", " user-firstName "`"]]
              [:br] "Geburtsdatum " (date-conv (:user-birthday @!actual-user))
              [:br] "Gültig bis Gültigkeitsdatum/Austellungsdatum + 5 Jahre "
              [:br] "jedoch maximum Hochladedatum + 5 Jahre"

              (if @!reject
                [reject-form !st document]
                [qualification-document-form !st date-to-ok?])

              ]
             ]]


           [mui/grid {:container false :item true :xs 6}
            [:f> backend-file/download-wrapper userDocument-path
             (fn [url]
               (let [url (when url (js/URL. url))]
                 (when url
                   (.set (.-searchParams url) "inline" "true"))
                 [:div {:style {:margin "5px -10px 0 30px"}}
;                  [:pre (pr-str document)]

                  (when userDocument-uuid
                    [:a {:title "Klick um in neuem Tab zu öffnen"
                         :href  url :target "_blank"}
                     [:div {:style {:position "relative" :float "right" :paddingLeft "20px"}} "Anlage öffnen"] [:br]
                     [backend-file/img {:hash     userDocument-path
                                        :preview? true
                                        :style    {:position "relative" :float "right" :width "100%" :maxWidth "400px" :maxHeight "600px" :objectFit "contain"} :alt "Ansicht"}]
                     [mui/typography {:style {:wordBreak "break-all" :float "right" :font-size "11px"}} (or userDocument-fileName userDocument-path)]])


                  [mui/text-field {
                                   :style           {:background-color (if (not= "" @!lrClearance-qualification-message) "#ffd6d2" "#ffffff") }
                                   :fullWidth       true
                                   :multiline       true
                                   :minRows         3
                                   :placeholder     "Z.B.: Auszug aus dem Mitarbeiterakt"
                                   :helper-text     (if (= "" @!lrClearance-qualification-message) "Bitte Begründung eingeben" "")
                                   :onChange        (fn [e] (reset! !lrClearance-qualification-message (h/event-value e)))
                                   :label           (str "Begründung")
                                   :defaultValue    (str "" @!lrClearance-qualification-message)
                                   :InputLabelProps {:disableAnimation true :shrink true}
                                   }]]

                 ))]


            [:br]
            [:br]
            [:br]
            ]

           [:div {:style {:height "10px"}}]

           (when !show-doc-assign-modal
             [mui/grid {:container false :item true :xs 12}
              [mui/button
               {:variant   "contained"
                :startIcon (r/as-element [code])
                :style     {:marginBottom 10}
                :onClick   (fn []
                             (reset! !show-doc-assign-modal {:showTomId @!show :type :training})
                             (reset! !show nil))
                }
               "Dokument wählen"]])


           [mui/grid {:container false :item true :xs 4}
            [mui/button
             {:variant   "contained"
              :startIcon (r/as-element [keyboard-arrow-left])
              :style     {:marginRight 50}
              :onClick   (fn []
                           (reset! !show nil)
                           (reset! !invalidated true))
              }
             "Abbrechen"]]

           (cond

             (and userDocument-rejected (or (= "" @!rejectMessage) (= userDocument-rejectMessage @!rejectMessage)))
             [mui/grid {:container false :item true :xs 6}
              [mui/button
               {:color     "secondary"
                :style     {:float "right"}
                :variant   "contained"
                :startIcon (r/as-element [cancel])
                :onClick   (fn []
                             (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                               {:userDocument-readonly      false
                                                                :userDocument-type          "lebensretter-qualification"
                                                                :userDocument-rejectMessage ""
                                                                :userDocument-rejected      false
                                                                }
                                                               (fn []
                                                                 (d-user/>user-edit-field user-uuid {:user-lrWaiting true}
                                                                                          (fn []
                                                                                            (d-user/actual-user-invalidate !actual-user)
                                                                                            (reset! !invalidated true)
                                                                                            )))
                                                               ))
                }
               "Ablehnung zurücknehmen"]]

             @!reject
             [mui/grid {:container false :item true :xs 8}

              [mui/button
               {:variant "contained"
                :style   {:marginRight 50}
                :onClick (fn []
                           (reset! !reject false)
                           (reset! !rejectMessage ""))

                }
               "nicht Ablehnen"]
              [mui/button
               {:color     "primary"
                :style     {:float "right"}
                :variant   "contained"
                :disabled  (or (= "" @!rejectMessage) (and (not userDocument-rejected) (= userDocument-rejectMessage @!rejectMessage)))
                :startIcon (r/as-element [cancel])
                :onClick   (fn []
                             (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                               {:userDocument-readonly      false
                                                                :userDocument-rejectMessage (:userDocument-rejectMessage @!st)
                                                                :userDocument-type          "lebensretter-qualification"
                                                                :userDocument-rejected      true
                                                                :userDocument-locked        false
                                                                :userDocument-isTraining    false
                                                                }
                                                               (fn []
                                                                 (d-user/>user-edit-field user-uuid {:user-lrWaiting true}
                                                                                          (fn []
                                                                                            (d-user/actual-user-invalidate !actual-user)
                                                                                            (reset! !invalidated true)
                                                                                            (reset! !show nil)
                                                                                            )))
                                                               ))
                }
               "Ablehnen"]]

             :else
             [mui/grid {:container false :item true :xs 8}

              (when (:userDocument-uuid document)
                [mui/button
                 {:color     "secondary"
                  :variant   "contained"
                  :startIcon (r/as-element [cancel])
                  :style     {:marginRight 50}
                  :onClick   #(reset! !reject true)
                  }
                 "Ablehnen"])
              (when (or (:userDocument-uuid document)
                        (and (:lrClearance-qualification-message @!st)
                             (> (count (:lrClearance-qualification-message @!st)) 0)))
                [mui/button
                 {:color     "primary"
                  :style     {:float "right" :display ()}
                  :variant   "contained"
                  :disabled  (not confirmable?)
                  :startIcon (r/as-element [check])
                  :onClick   (fn []
                               (let [save-cl-fn (fn []
                                                  (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                                                          (merge {:lrClearance-type                  (:lrClearance-type @!st)
                                                                                                  :lrClearance-qualification-message (:lrClearance-qualification-message @!st)
                                                                                                  }
                                                                                                 (when-let [d (:userDocument-uuid document)] [:_trainingDocument-uuid d])
                                                                                                 (when qualification-validate? [:lrClearance-qualification-valid true])
                                                                                                 (when qualification-validate? [:lrClearance-qualification-until (date-conv-back (:userDocument-validTo @!st))]))
                                                                                          (fn [lrClearance]
                                                                                            (let [show-tomId @!show]
                                                                                              (d-user/actual-user-invalidate !actual-user)
                                                                                              (reset! !invalidated true)
                                                                                              (reset! !show nil)))))]
                                 (if (:userDocument-uuid document)
                                   (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                                     {:userDocument-readonly   true
                                                                      :userDocument-rejected   false
                                                                      :userDocument-type       "lebensretter-qualification"
                                                                      :userDocument-isTraining true
                                                                      :userDocument-validFrom  (date-conv-back (:userDocument-validFrom @!st))
                                                                      :userDocument-validTo    (date-conv-back (:userDocument-validTo @!st))
                                                                      }
                                                                     save-cl-fn)
                                   (save-cl-fn))))
                  }

                 "Bestätigen"
                 ])
              ])]]]))))

(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )

(defn modal-by-tomId [!tomId !document-uuid !show-doc-assign-modal]
  (let [!actual-user (r/atom {})]
    (fn []
      (let [user @!actual-user
            tomId @!tomId
            document-uuid @!document-uuid]
        (when (and (pos? tomId) (not= tomId (:reqTomId user))) (get-user-details !actual-user tomId))
        (if (or (not= @!tomId (:reqTomId user)) (:error user))
          ;no data
          [mui/modal
           {:className        "training-load-modal"
            :aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (pos? tomId)
            :onClose          (fn []
                                (reset! !actual-user {})
                                (reset! !tomId nil))
            }
           [:div
            {:class "modal"
             :style {:width 400}}
            [:h4 (str "Qualifikationsnachweis prüfen ")]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error user)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click (fn []
                          (reset! !actual-user {})
                          (reset! !tomId nil))
              }
             "Schließen"]
            ]]
          ;has data
          (do
            (log/debug "find " document-uuid " in " (clj->js (map :userDocument-uuid (:user-userDocument @!actual-user))))
            (let [document (first (filter (fn [e] (and (= (:userDocument-uuid e) document-uuid))) (:user-userDocument @!actual-user)))]
              [modal !actual-user document !tomId !show-doc-assign-modal true]
              ))

          )))))